// Lightweight Web Audio SFX synth — no external assets.
// Sounds are generated on the fly and respect the user's sound setting (gated by the caller).

let ctx = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (c, freq, start, dur, type = "sine", gain = 0.15) => {
  const t0 = c.currentTime + start;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.03);
};

export const playSound = (name) => {
  const c = getCtx();
  if (!c) return;
  switch (name) {
    case "select":
      tone(c, 520, 0, 0.08, "triangle", 0.07);
      break;
    case "correct":
      tone(c, 660, 0, 0.1, "sine", 0.13);
      tone(c, 880, 0.09, 0.15, "sine", 0.13);
      break;
    case "wrong":
      tone(c, 180, 0, 0.18, "sawtooth", 0.1);
      tone(c, 130, 0.07, 0.22, "sawtooth", 0.09);
      break;
    case "hint":
      tone(c, 740, 0, 0.09, "triangle", 0.11);
      tone(c, 988, 0.08, 0.13, "triangle", 0.1);
      break;
    case "win":
      [523.25, 659.25, 783.99, 1046.5].forEach((f, i) =>
        tone(c, f, i * 0.12, 0.24, "triangle", 0.15)
      );
      break;
    default:
      break;
  }
};
